import { FC } from 'react';

// Components
import { SocialIcon } from './SocialIcon';

// Utils
import { mapResponseToSocial, returnBuiltSocialData } from '@sportal365/smp-widget-utils/src/buildSocialUrls';

// Types
import { ISocials } from '../../../types';

const SOCIAL_ICONS_POSITIONS = ['web', 'instagram', 'facebook', 'twitter', 'youtube'];

interface Props {
  data: ISocials;
  showSocialIcons: boolean;
}

const SocialIconsList: FC<Props> = ({ data, showSocialIcons }) => {
  const socials: ISocials = mapResponseToSocial(data);

  const icons: ISocials = SOCIAL_ICONS_POSITIONS.reduce<ISocials>((acc, key) => {
    if (socials[key]) {
      acc[key] = socials[key];
    }
    return acc;
  }, {});

  if (!showSocialIcons) return null;

  return (
    <div className='social-icons-container flex gap-2 w-full justify-between tb:w-auto  tb:justify-end'>
      {icons &&
        Object.keys(icons).map((social, index) => {
          if (icons[social]) {
            const socialUrl = returnBuiltSocialData(icons, social);
            return <SocialIcon key={index} href={socialUrl?.length > 0 ? socialUrl : ''} social={social} />;
          }
          return null;
        })}
    </div>
  );
};

export default SocialIconsList;
